// extracted by mini-css-extract-plugin
export default {"RefSelectorTabs":"RefSelector-module__RefSelectorTabs--nkSFr","RefSelectorTabLink":"RefSelector-module__RefSelectorTabLink--WGX7u"};